// extracted by mini-css-extract-plugin
export default {"description":"SubscriptionManager_description__cFTFp","checkmark":"SubscriptionManager_checkmark__4P7Fu"};